import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/diagnostic-admin')({
  component: () => <Navigate to="/admin/diagnostic/questions" replace />,
});
